import { Collection } from '@app/features/collections/models/collection';
import { cameoGreen } from './collections/s-and-p-cameo-green';
import { meridian } from './collections/s-and-p-meridian';
import { artisanWhite } from './collections/s-and-p-artisan-white';
import { oraGloss } from './collections/s-and-p-ora-gloss';
import { blush } from '@assets/collections/data/collections/s-and-p-blush';
import { cameoBeige } from '@assets/collections/data/collections/s-and-p-cameo-beige';
import { artisan } from '@assets/collections/data/collections/s-and-p-artisan';
import { alura } from '@assets/collections/data/collections/sp-alura';
import { studioBase } from '@assets/collections/data/collections/sp-studio-base';
import { nomad } from '@assets/collections/data/collections/sp-nomad';
import { curvy } from '@assets/collections/data/collections/sp-curvy';
import { duo } from '@assets/collections/data/collections/ona-duo';
import { fika } from '@assets/collections/data/collections/one-fika';
import { dot } from '@assets/collections/data/collections/ona-dot';
import { duna } from '@assets/collections/data/collections/ona-duna';
import { gallerySerene } from '@assets/collections/data/collections/sp-gallery-serene';
import { meridianIvory } from '@assets/collections/data/collections/s-and-p-meridian-ivory';
import { nuo } from '@assets/collections/data/collections/ona-nuo';
import { studioUrbanBeach } from '@assets/collections/data/collections/sp-studio-urban-beach';

export const collections: Map<string, Collection> = new Map<string, Collection>([
  [cameoGreen.id, cameoGreen],
  [cameoBeige.id, cameoBeige],
  [meridian.id, meridian],
  [meridianIvory.id, meridianIvory],
  [artisan.id, artisan],
  [artisanWhite.id, artisanWhite],
  [oraGloss.id, oraGloss],
  [blush.id, blush],
  [alura.id, alura],
  [studioBase.id, studioBase],
  [studioUrbanBeach.id, studioUrbanBeach],
  [nomad.id, nomad],
  [curvy.id, curvy],
  [duo.id, duo],
  [nuo.id, nuo],
  [fika.id, fika],
  [dot.id, dot],
  [duna.id, duna],
  [gallerySerene.id, gallerySerene]
]);

export const collectionsByBrand = new Map<string, Collection[]>(groupByKey([...collections.values()], 'brandId'));

function groupByKey<T, K extends keyof T>(array: T[], key: K): Map<string, T[]> {
  return array.reduce((acc, item) => {
    const keyValue = item[key] as unknown as string;
    if (!acc.get(keyValue)) {
      acc.set(keyValue, []);
    }
    acc.get(keyValue).push(item);
    return acc;
  }, new Map<string, T[]>());
}
